import AirtableTable from "../AirtableTable";
import { Announcement } from "../models";
import { airtableFields, airtableTables } from "../schema";

export class AnnouncementTable extends AirtableTable<Announcement> {
  constructor(instance: any) {
    super(instance, airtableTables.announcements);

    this.fields = [
      airtableFields.announcements.title,
      airtableFields.announcements.announcement,
      airtableFields.announcements.liveDate
    ]
  }

  getItemsForToday = (limit?: number) => {
    return this.list({ sort: [{ field: airtableFields.announcements.liveDate, direction: "desc" }] })
      .then((items: Announcement[]) => items.filter((item: any) =>
        new Date(item[airtableFields.announcements.liveDate]) <= new Date()).slice(0, limit));
  }

  getUpcomings = (limit?: number) => {
    return this.list({ sort: [{ field: airtableFields.announcements.liveDate, direction: "desc" }] })
      .then((items: Announcement[]) => items.filter((item: any) =>
        new Date(item[airtableFields.announcements.liveDate]) >= new Date()).slice(0, limit));
  }
}
